export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.5 2a1 1 0 011 1v6.587c.627.63 1.218 1.25 1.707 1.983.581.872 1.001 1.873 1.274 3.234A1 1 0 0118.5 16H13v7h-2v-7H5.5a1 1 0 01-.981-1.196c.272-1.361.692-2.362 1.273-3.234.49-.733 1.08-1.352 1.707-1.983V3l.005-.103A1 1 0 018.5 2h7zm-6 8a1 1 0 01-.293.707c-.764.764-1.315 1.32-1.75 1.973A5.827 5.827 0 006.804 14h10.392a5.825 5.825 0 00-.653-1.32c-.435-.653-.986-1.209-1.75-1.973A1 1 0 0114.5 10V4h-5v6z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};